import React from "react";
import Carousel from "react-material-ui-carousel";
import {
  Box,
  Typography,
  CardContent,
  CardHeader,
  Card,
  Stack,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { MostPurchasedProduct } from "@/app/models/dqDashboard/types";
import { faReceipt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import defaultProductImg from "../../../../img/default-image_420.png";
import { Link } from "react-router-dom";

interface Props {
  data: MostPurchasedProduct[];
}

const MostPurchasedProductsCard: React.FC<Props> = ({ data }) => {
  const theme = useTheme();

  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isMd = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isLgUp = useMediaQuery(theme.breakpoints.up("lg"));

  let itemsPerSlide = 1;
  if (isLgUp) itemsPerSlide = 5;
  else if (isMd) itemsPerSlide = 3;
  else if (isSm) itemsPerSlide = 2;
  else itemsPerSlide = 1;

  const slides = [];
  for (let i = 0; i < data.length; i += itemsPerSlide) {
    slides.push(data.slice(i, i + itemsPerSlide));
  }

  return (
    <Card
      variant="outlined"
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        border: "2px solid #e6ecf0",
        borderRadius: "10px",
      }}
    >
      <CardHeader
        title={
          <Stack direction="row" alignItems="center" spacing={1}>
            <Box className="iconHeader">
              <FontAwesomeIcon icon={faReceipt} color="#666666" size="sm" />
            </Box>
            <Typography
              sx={{ fontSize: "14px", color: "#494440", fontWeight: "bold" }}
            >
              My Most Purchased
            </Typography>
          </Stack>
        }
      />
      <CardContent
        sx={{ flex: 1, display: "flex", flexDirection: "column", p: 0 }}
      >
        <Carousel
          autoPlay={true}
          animation="slide"
          indicators={false}
          navButtonsAlwaysVisible
          interval={2500}
          swipe
          navButtonsProps={{
            style: {
              backgroundColor: "transparent",
              color: "black",
              borderRadius: 0,
            },
          }}
        >
          {slides.map((group, slideIdx) => (
            <Box
              key={slideIdx}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                flexWrap: "wrap",
                minHeight: { xs: 150, sm: 200, md: 250 },
              }}
            >
              {group.map((product, index) => (
                <Box
                  key={index}
                  className="freqpurchased-product-box"
                  textAlign="center"
                  sx={{
                    flex: "0 0 auto",
                    width: { xs: 140, sm: 160, md: 180 },
                    height: { xs: 150, sm: 200, md: 250 },
                  }}
                >
                  <Link to={product.productUrl}>
                    <img
                      src={
                        product.picture?.imageUrl
                          ? `${process.env.REACT_APP_CDN_URL}/images/general/picture_${product.picture.imageUrl}`
                          : defaultProductImg
                      }
                      alt={product.picture?.alternateText || product.name}
                      title={product.picture?.title || product.name}
                      style={{
                        height: "120px",
                        width: "auto",
                        objectFit: "contain",
                        display: "block",
                        margin: "0 auto",
                      }}
                    />
                  </Link>

                  <Typography
                    variant="body1"
                    sx={{ mt: 1, fontSize: 16, color: "#494440" }}
                  >
                    <strong>
                      <Link
                        to={product.productUrl}
                        style={{ color: "#494440", textDecoration: "none" }}
                      >
                        {product.name}
                      </Link>
                    </strong>
                  </Typography>
                </Box>
              ))}
            </Box>
          ))}
        </Carousel>
      </CardContent>
    </Card>
  );
};

export default MostPurchasedProductsCard;
